import { Link } from "react-router-dom";
import { ModeToggle } from "@/components/theme-toggle";
import { Button } from "@/components/ui/button";
import { useSupabaseSession } from "@/hooks/useSupabaseSession";
import { supabase } from "@/integrations/supabase/client";

export function SiteHeader() {
  const { user } = useSupabaseSession();
  return (
    <header className="w-full border-b">
      <div className="mx-auto max-w-6xl px-4 h-14 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to="/" className="font-semibold">FanzUnlimited</Link>
          <Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground">Blog</Link>
        </div>
        <div className="flex items-center gap-2">
          <ModeToggle />
          {user ? (
            <div className="flex items-center gap-2">
              <Link to="/admin"><Button variant="ghost" size="sm">Dashboard</Button></Link>
              <Button size="sm" variant="outline" onClick={() => supabase.auth.signOut()}>Sign out</Button>
            </div>
          ) : (
            <Link to="/auth"><Button size="sm">Sign in</Button></Link>
          )}
        </div>
      </div>
    </header>
  );
}

export default SiteHeader;